import React, { memo } from 'react';

import { useTranslation } from 'providers/GILT.provider';

const UndoTagButton = ({ className, tabIndex, handleUndo }) => {
  const { t } = useTranslation();
  return (
    <button data-bem="UndoTagButton" className={className} tabIndex={tabIndex} onClick={handleUndo}>
      {t('clientTags.undoButton')}
    </button>
  );
};
export default memo(UndoTagButton);
